import React from "react"
import { DatoContentBaseProps } from "../../types"
import BannerStrip from "@components/BannerStrip"

interface DatoCmsComponentBannerStripProps extends DatoContentBaseProps {}

const DatoCmsComponentBannerStrip: React.FC<
  DatoCmsComponentBannerStripProps
> = ({
  text,
  height,
  fontWeight,
  redirectLink,
  backgroundColor,
  backgroundImage,
  textColor,
}) => {
  return (
    <BannerStrip
      text={text}
      height={height}
      fontWeight={fontWeight}
      redirectLink={redirectLink}
      backgroundColor={backgroundColor?.hex}
      backgroundImage={backgroundImage?.responsiveImage}
      backgroundImageSrc={
        backgroundImage?.responsiveImage?.src || backgroundImage?.url
      }
      textColor={textColor?.hex}
    />
  )
}

export default DatoCmsComponentBannerStrip
